/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useState } from "react";
import { yupResolver } from "@hookform/resolvers/yup";
import { Input, Typography } from "@material-tailwind/react";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import * as Yup from "yup";
import { ThunkDispatch } from "@reduxjs/toolkit";
import { InformationCircleIcon } from "@heroicons/react/24/solid";
import { UserSubmitFormChangePassword } from "@/utils/interface.global";
import { AiOutlineEye, AiOutlineEyeInvisible } from "react-icons/ai";
import { getUserData, updateData } from "@/redux/slices/userSlices";
import Api from "@/components/api/api";
import ToastProvider from "@/hooks/useToastProvider";
import { useNavigate } from "react-router-dom";
import btn_update from "@/assets/btn_update.png";

const formSchema = Yup.object().shape({
  currentpassword: Yup.string()
    .required("Mật khẩu hiện tại không được để trống")
    .min(4, "Mật khẩu hiện tại phải có ít nhất 4 ký tự"),
  newpassword: Yup.string()
    .required("Mật khẩu mới không được để trống")
    .min(4, "Mật khẩu phải có ít nhất 4 ký tự"),
  confirmpassword: Yup.string()
    .required("Nhập lại mật khẩu mới không được để trống")
    .oneOf([Yup.ref("newpassword")], "Nhập lại mật khẩu mới không đúng"),
});

const ChangePassword: React.FC = () => {
  const navigate = useNavigate();
  const userData = useSelector(getUserData);
  const [isPassword, setIsPassword] = useState(true);
  const dispatch = useDispatch<ThunkDispatch<any, any, any>>();
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<UserSubmitFormChangePassword>({
    mode: "onTouched",
    resolver: yupResolver(formSchema),
  });

  const handleSubmitForm = async (values: UserSubmitFormChangePassword) => {
    try {
      const reqUrl = "/change-password";
      const params = {
        key: userData.key_login,
        user_id: userData.id,
        currentpassword: values.currentpassword,
        newpassword: values.newpassword,
      };
      const res = await Api.post(reqUrl, params);
      if (!res.data.status) {
        return ToastProvider({ type: "error", content: res.data.message });
      } else {
        ToastProvider({ type: "success", content: res.data.message });
        dispatch(updateData(res.data.data));
        navigate("/Manage", { replace: true });
      }
    } catch (error) {
      ToastProvider({
        type: "error",
        content: "Có lỗi xảy ra trong quá trình tải data. Vui lòng thử lại",
      });
    }
  };

  return (
    <div className="login-container relative">
      <h1 className="text-xl md:text-2xl sm:text-2xl font-bold">
        Thay Đổi Mật Khẩu
      </h1>
      <div className="w-5/6 flex flex-col gap-5 py-5">
        <Input
          {...register("currentpassword")}
          variant="standard"
          color="gray"
          label="Mật Khẩu Hiện Tại"
          type={isPassword ? "password" : "text"}
          error={errors.currentpassword && true}
          icon={
            isPassword ? (
              <AiOutlineEye
                className="cursor-pointer"
                onClick={() => setIsPassword(!isPassword)}
              />
            ) : (
              <AiOutlineEyeInvisible
                className="cursor-pointer"
                onClick={() => setIsPassword(!isPassword)}
              />
            )
          }
        />
        {errors.currentpassword && (
          <Typography
            variant="small"
            color="red"
            className="flex items-center gap-1 font-normal mx-2"
          >
            <InformationCircleIcon className="w-4 h-4 -mt-px" />
            {errors.currentpassword.message as string}
          </Typography>
        )}
        <Input
          {...register("newpassword")}
          variant="standard"
          color="gray"
          label="Mật Khẩu Mới"
          type={isPassword ? "password" : "text"}
          error={errors.newpassword && true}
          icon={
            isPassword ? (
              <AiOutlineEye
                className="cursor-pointer"
                onClick={() => setIsPassword(!isPassword)}
              />
            ) : (
              <AiOutlineEyeInvisible
                className="cursor-pointer"
                onClick={() => setIsPassword(!isPassword)}
              />
            )
          }
        />
        {errors.newpassword && (
          <Typography
            variant="small"
            color="red"
            className="flex items-center gap-1 font-normal mx-2"
          >
            <InformationCircleIcon className="w-4 h-4 -mt-px" />
            {errors.newpassword.message as string}
          </Typography>
        )}
        {/* confirmpassword */}
        <Input
          {...register("confirmpassword")}
          variant="standard"
          color="gray"
          label="Nhập Lại Mật Khẩu Mới"
          type={isPassword ? "password" : "text"}
          error={errors.confirmpassword && true}
          icon={
            isPassword ? (
              <AiOutlineEye
                className="cursor-pointer"
                onClick={() => setIsPassword(!isPassword)}
              />
            ) : (
              <AiOutlineEyeInvisible
                className="cursor-pointer"
                onClick={() => setIsPassword(!isPassword)}
              />
            )
          }
        />
        {errors.confirmpassword && (
          <Typography
            variant="small"
            color="red"
            className="flex items-center gap-1 font-normal mx-2"
          >
            <InformationCircleIcon className="w-4 h-4 -mt-px" />
            {errors.confirmpassword.message as string}
          </Typography>
        )}
      </div>
      <div className="w-full flex z-10">
        <button
          className="w-[30%] mx-auto"
          onClick={handleSubmit(handleSubmitForm)}
        >
          <img src={btn_update} />
        </button>
      </div>
    </div>
  );
};

export default ChangePassword;
